<template>
  <div class="home-lawyer">
    <nav-header :activeIndex="2" />
    <main class="home-lawyer-content">
      <div class="home-lawyer-content-inner">
        <div class="home-lawyer-content-search-wrap">
          <div class="search">
            <input type="text" placeholder="请输入律师姓名" v-model="searchVal"  @keydown="handleKeySearch">
            <div @click="handleSearch">
              <Icon type="search" class="icon" />
            </div>
          </div>
          <div class="location">
            <img src="../home/assets/icon-location-24.png" alt="">
            <div class="location-wrap">
              <span>{{location ? location[1] : city}}</span>
              <div class="select-wrap">
                <el-cascader
                  v-model="location"
                  :options="cityList"
                  :show-all-levels="false"
                  :props="{value: 'name', label: 'name', children: 'cityList'}"
                  @change="selectCity" />
              </div>
            </div>
          </div>
        </div>
        <div class="home-lawyer-content-field">
          <div class="home-lawyer-content-field-item" v-for="(item, index) in field"
               :key="index" :class="index===activeIndex?'active-field':null"
               @click="chooseField(index, item.title)">{{item.title}}
          </div>
          <div class="home-lawyer-content-field-item" style="opacity: 0">其他</div>
          <div class="home-lawyer-content-field-consult" @click="getMeiQia">不知道怎么选择律师？圣诉专员帮您</div>
        </div>
        <lawyer-list :lawyerList="lawyerList" @getCity="getCity" :isLocation="false">
          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              prev-text="< 上一页"
              next-text="下一页 >"
              :total="total"
              :page-size="pageSize"
              :current-page="pageIndex"
              hide-on-single-page
              @current-change="handleChange"
            >
            </el-pagination>
          </div>
        </lawyer-list>
      </div>
    </main>
  </div>
</template>

<script>
  import Icon from '@/common-components/icon'
  import LawyerList from '@/common-components/lawyer-list'
  import NavHeader from '@/common-components/nav-header'
  import api from './api'
  import { Message } from 'element-ui/lib'
  import { clickShowMeiQia } from '@/utils/meiqia'
  export default {
    name: 'home-lawyer',
    components: {
      Icon, LawyerList, NavHeader
    },
    data () {
      return {
        field: [
          {title: '婚姻家庭'},
          {title: '刑事辩护'},
          {title: '合同纠纷'},
          {title: '债权债务'},
          {title: '房产纠纷'}
        ],
        lawyerList: [],
        location: '',
        total: 0,
        pageIndex: 1,
        pageSize: 12,
        searchVal: '',
        city: '',
        activeIndex: '',
        expertField: '',
        cityList: []
      }
    },
    mounted () {
      this.expertField = this.$route.query.expertField || ''
      api.getProvinceList().then(res => {
        this.cityList = res.data.data
      })
    },
    methods: {
      // 路由跳转
      navigatorRoute (path) {
        let router = this.$router.resolve({
          name: path
        })
        window.open(router.href)
      },
      // 获取律师列表
      async getPositionLawyer () {
        let obj = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          lawyerName: this.searchVal.slice(0, 100),
          city: this.city,
          expertField: this.expertField
        }
        let res = await api.getPositionLawyerList(obj)
        if (res.data.isSuccess) {
          this.lawyerList = res.data.data.list
          this.total = res.data.data.total
        } else {
          Message.error(res.data.resultMsg)
        }
      },
      // 改变页数
      handleChange (val) {
        this.pageIndex = val
        this.getPositionLawyer()
      },
      // 搜索名称
      handleSearch () {
        this.pageIndex = 1
        this.getPositionLawyer()
      },
      handleKeySearch (event) {
        let e = event || window.event
        if (e && e.keyCode === 13) { // enter 键
          this.pageIndex = 1
          this.getPositionLawyer()
        }
      },
      // 选择城市
      selectCity () {
        this.city = this.location[1]
        this.pageIndex = 1
        this.getPositionLawyer()
      },
      // 选择领域
      chooseField (index, title) {
        this.activeIndex = index
        this.expertField = title
        this.pageIndex = 1
        this.getPositionLawyer()
      },
      // 获取地理位置
      getCity (city) {
        this.city = city
        this.getPositionLawyer()
      },
      // 连接商桥
      getMeiQia () {
        clickShowMeiQia()
      }
    }
  }
</script>

<style lang='stylus' scoped>
  @import '../../styles/constant.styl'
  .home-lawyer {
    &-content {
      margin-top .72rem
      background #f7f7f7
      &-inner {
        width: 9.4rem
        margin 0 auto
        padding-top .72rem
      }
      &-search-wrap {
        display flex
        align-items center
        .search {
          flex 1
          height: .48rem
          background #fff
          padding 0 .2rem
          line-height: .72rem
          display flex
          border-radius .04rem
          border 1px solid #e1e1e1
          input {
            flex 1
            font-size: .16rem
          }
          input::-webkit-input-placeholder{
            color: #a9a9a9
          }
          .icon {
            font-size: .24rem
            color: #a9a9a9;
            position relative
            top -.07rem
          }
        }
        .location {
          margin-left .2rem
          display: flex
          position relative
          img {
            width: .24rem
            height: .24rem
            flex shrink
            position relative
            top .04rem
          }
          .location-wrap {
            position relative
            .select-wrap {
              width: 1rem
              position absolute
              top 0
              left -.5rem
            }
            span {
              font-size: .12rem
              color: #ed6c00;
              position relative
              top .04rem
              bottom .05rem
              margin-left .1rem
              font-weight: 500
            }
          }
        }
      }
      &-field {
        display flex
        justify-content space-around
        flex-wrap wrap
        margin-top .2rem
        margin-bottom -.24rem
        &-item {
          width: 3rem
          height: .48rem
          border-radius: .04rem
          text-align center
          font-size: .16rem
          line-height .48rem
          background-color: #ffffff;
          margin-bottom .2rem
          cursor: pointer
        }
        &-consult {
          font-size: .16rem
          color: #ed6c00;
          text-decoration underline
          margin-top .10rem
          cursor pointer
        }
      }
      .active-field {
        color: #ED6C00
        font-weight: 600
      }
      .pagination {
        width: 100%
        margin .28rem 0 .48rem 0
        text-align center
      }
    }
  }
</style>

<style lang="stylus">
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    background #f7f7f7
    border-radius 50%
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #fa8919
  }
  .el-input__suffix {
    display: none
  }
  .el-input--suffix .el-input__inner {
    background transparent
    border 0
    color: transparent
  }
  .el-cascader-menu {
    padding .06rem .16rem !important
  }
  .el-scrollbar__view.el-cascader-menu__list li {
    line-height .32rem
  }
  .el-input--suffix .el-input__inner::-webkit-input-placeholder{
    color: transparent
  }
  .el-scrollbar__view.el-cascader-menu__list li {
    cursor pointer
  }
</style>



// WEBPACK FOOTER //
// src/components/lawyer/lawyer.vue